import {
    Container,
    Stack,
    Typography,
    Grid,
    Card,
    Box,
    Select,
    MenuItem,
    InputLabel,
    FormControl,
    Avatar,
    Divider,
    Fade,
    Zoom,
    Paper,
    Chip,
    IconButton,
    Tooltip,
  } from "@mui/material";
  import React, { useEffect, useState } from "react";
  import CardMedia from "@mui/material/CardMedia";
  import { useNavigate } from 'react-router-dom';
  import { GetAll, apiURL, Put } from "../../../utils/apiCalls";
  import { 
    FormatQuote, 
    FilterList, 
    Visibility,
    Category,
    PhotoLibrary,
    Business,
    Image
  } from '@mui/icons-material';
  
  
  const Quotations = () => {
    const navigate = useNavigate();  
    const [category, setCategory] = useState([])
    const [slectcategory, setSelectcategory] = useState(1)
    const [posterdata,setPosterdata] = useState(1)
  
  
    const getcategory  = async () => {
      const response = await GetAll(apiURL + "/api/v1/posters/Allcategory");
      if (response && response.data && response.data.status) {
        setCategory(response.data.data);
        console.log(response.data.data);
      }
    };
    const getposter = async (e) => {
      
      const response = await GetAll(apiURL + `/api/v1/posters/categorytype/QUOTES`);    
      if (response && response.data && response.data.status) {
        setPosterdata(response.data.data);
        console.log(response.data.data);
      }
    };
    useEffect(() => {
    //   getcategory();
     getposter(1)
    }, []);
    return (
      <Container sx={{ m: 0, width: "100%", maxWidth: "100%" }} maxWidth={false}>
        <Fade in timeout={800}>
          <Box sx={{ mb: 4 }}>
            <Stack direction="row" alignItems="center" spacing={3} sx={{ mb: 3 }}>
              <Avatar sx={{ 
                bgcolor: '#1976d2', 
                width: 48, 
                height: 48,
                boxShadow: '0 4px 12px rgba(25, 118, 210, 0.3)'
              }}>
                <FormatQuote sx={{ fontSize: 24, color: 'white' }} />
              </Avatar>
              <Box>
            <Typography variant="h5" component="h1" fontWeight="bold" color="text.primary">
              Quotations Gallery
            </Typography>
                <Typography variant="subtitle2" color="text.secondary">
                  Professional quotation templates for your business needs
                </Typography>
              </Box>
            </Stack>
            <Divider sx={{ my: 2 }} />
          </Box>
        </Fade>

        {/* Main Content */}
        <Zoom in timeout={1000}>
          <Card elevation={4} sx={{ borderRadius: 3, overflow: 'hidden' }}>
            <Box sx={{ p: 3, background: 'linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%)' }}>
              <Stack direction="row" alignItems="center" spacing={2}>
                <FilterList sx={{ color: '#1976d2', fontSize: 28 }} />
                <Typography variant="h6" fontWeight="600" color="text.primary">
                  Available Templates
                </Typography>
                <Chip
                  label={`${posterdata?.length || 0} Quotes`}
                  sx={{
                    background: '#1976d2',
                    color: 'white',
                    fontWeight: 600,
                    ml: 'auto'
                  }}
                />
              </Stack>
            </Box>

            <Box sx={{ p: 3 }}>
              {posterdata?.length > 0 ? (
                <Fade in timeout={1200}>
                  <Grid container spacing={3}>
                    {posterdata.map((data, index) => (
                      <Grid item xs={12} sm={6} md={4} key={data.id}>
                        <Zoom in timeout={800 + index * 100}>
                          <Card
                            elevation={4}
                            sx={{
                              borderRadius: 3,
                              overflow: 'hidden',
                              cursor: 'pointer',
                              transition: 'all 0.3s ease',
                              '&:hover': {
                                transform: 'translateY(-8px)',
                                boxShadow: '0 12px 24px rgba(25, 118, 210, 0.2)',
                                '& .overlay': {
                                  opacity: 1
                                }
                              }
                            }}
                            onClick={() => navigate(`/dashboard/QuotationsEdit/${data.id}`)}
                          >
                            <Box sx={{ position: 'relative' }}>
                  <CardMedia
                    component="img"
                      image={data.filepaths3}
                                alt="Quotation Template"
                                sx={{
                                  objectFit: "cover",
                                  height: 280,
                                  transition: 'transform 0.3s ease'
                                }}
                              />
                              <Box
                                className="overlay"
                                sx={{
                                  position: 'absolute',
                                  top: 0,
                                  left: 0,
                                  right: 0,
                                  bottom: 0,
                                  background: 'linear-gradient(135deg, rgba(25, 118, 210, 0.9) 0%, rgba(21, 101, 192, 0.9) 100%)',
                                  display: 'flex',
                                  alignItems: 'center',
                                  justifyContent: 'center',
                                  opacity: 0,
                                  transition: 'opacity 0.3s ease'
                                }}
                              >
                                <Tooltip title="Edit Template">
                                  <IconButton
                                    sx={{
                                      background: 'rgba(255, 255, 255, 0.2)',
                                      backdropFilter: 'blur(10px)',
                                      border: '2px solid rgba(255, 255, 255, 0.3)',
                                      '&:hover': {
                                        background: 'rgba(255, 255, 255, 0.3)',
                                        transform: 'scale(1.1)'
                                      }
                                    }}
                                  >
                                    <Visibility sx={{ color: 'white', fontSize: 28 }} />
                                  </IconButton>
                                </Tooltip>
                              </Box>
                            </Box>
                            <Box sx={{ p: 2 }}>
                              <Stack direction="row" alignItems="center" spacing={1}>
                                <Image sx={{ color: '#1976d2', fontSize: 20 }} />
                                <Typography variant="body2" color="text.secondary" fontWeight="500">
                                  Template #{data.id}
                                </Typography>
                              </Stack>
                            </Box>
                          </Card>
                        </Zoom>
                      </Grid>
                    ))}
                  </Grid>
                </Fade>
              ) : (
                <Fade in timeout={800}>
                  <Paper
                    elevation={2}
                    sx={{
                      p: 6,
                      textAlign: 'center',
                      borderRadius: 3,
                      background: 'linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%)'
                    }}
                  >
                    <Avatar
                      sx={{
                        width: 80,
                        height: 80,
                        background: 'linear-gradient(135deg, #1976d2 0%, #1565c0 100%)',
                        mx: 'auto',
                        mb: 3
                      }}
                    >
                      <PhotoLibrary sx={{ fontSize: 40, color: 'white' }} />
                    </Avatar>
                    <Typography variant="h5" fontWeight="600" color="text.primary" gutterBottom>
                      No Quotation Templates Found
                    </Typography>
                    <Typography variant="body1" color="text.secondary">
                      There are currently no quotation templates available.
                    </Typography>
                  </Paper>
                </Fade>
              )}
            </Box>
                </Card>
        </Zoom>

        {/* Professional Stats Footer */}
        <Fade in timeout={1400}>
          <Paper
            elevation={2}
            sx={{
              mt: 4,
              p: 3,
              borderRadius: 3,
              background: 'linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%)'
            }}
          >
            <Grid container spacing={3}>
              <Grid item xs={12} md={4}>
                <Stack direction="row" alignItems="center" spacing={2}>
                  <Avatar sx={{ background: '#1976d2' }}>
                    <Business sx={{ color: 'white' }} />
                  </Avatar>
                  <Box>
                    <Typography variant="h6" fontWeight="600" color="text.primary">
                      Total Templates
                    </Typography>
                    <Typography variant="h4" fontWeight="700" color="#1976d2">
                      {posterdata?.length || 0}
                    </Typography>
                  </Box>
                </Stack>
              </Grid>
              <Grid item xs={12} md={4}>
                <Stack direction="row" alignItems="center" spacing={2}>
                  <Avatar sx={{ background: '#4caf50' }}>
                    <Category sx={{ color: 'white' }} />
                  </Avatar>
                  <Box>
                    <Typography variant="h6" fontWeight="600" color="text.primary">
                      Categories
                    </Typography>
                    <Typography variant="h4" fontWeight="700" color="#4caf50">
                      Quotes
                    </Typography>
                  </Box>
                </Stack>
          </Grid>
              <Grid item xs={12} md={4}>
                <Stack direction="row" alignItems="center" spacing={2}>
                  <Avatar sx={{ background: '#ff9800' }}>
                    <PhotoLibrary sx={{ color: 'white' }} />
                  </Avatar>
                  <Box>
                    <Typography variant="h6" fontWeight="600" color="text.primary">
                      Gallery Mode
                    </Typography>
                    <Typography variant="h4" fontWeight="700" color="#ff9800">
                      Active
                    </Typography>
        </Box>
                </Stack>
              </Grid>
            </Grid>
          </Paper>
        </Fade>
      </Container>
    );
  };
  
  export default Quotations;
  